export function useSearchParams() {
  const currentUrl = new URL(window.location.href);

  const page = parseInt(currentUrl.searchParams.get('page') || '1', 10) || 1;
  const pageSize = parseInt(currentUrl.searchParams.get('pageSize') || '50', 10) || 50;
  const term = currentUrl.searchParams.get('term') || '';
  return { page, term, pageSize };
}
